module.exports = __webpack_public_path__ + "img/tab3-active.daa52fdf.png";